module.exports = __webpack_public_path__ + "img/full3-min.f0a564a4.png";